import { useMsal } from "@azure/msal-react";
import { getSignedInAccount } from "auth/utils/getSignedInAccount";
import ConfirmationModal from "common/components/ConfirmationModal";
import React from "react";

const InvalidTenantPopup: React.FC = () => {
  const { instance } = useMsal();
  const account = getSignedInAccount(instance);

  if (!account) return null;

  const handleConfirm = async () => {
    try {
      await instance.logoutRedirect({ account });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ConfirmationModal
      open={true}
      title="Tenant Not Found"
      confirmLabel="Sign Out"
      mainButtonType="primary"
      defaultAction="confirm"
      onConfirm={handleConfirm}
    >
      It seems you've entered an invalid tenant. Please sign out and login with
      a different account.
    </ConfirmationModal>
  );
};

export default InvalidTenantPopup;
